// ─────────────────────────────────────────────────────────────────
// Glass-i — HR Departments API client (Stage HRMS-1).
// Thin axios wrappers around /api/erp/hrms/departments/*.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/hrms/departments';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrDepartmentsApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups:  (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  create:   (payload)     => client.post(BASE, payload).then(unwrap),
  update:   (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:   (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  bulkSave: (payload)     => client.post(`${BASE}/bulk-save`, payload).then(unwrap)
};

// Soft-fail lookup for dropdown consumers (returns null on error).
export async function loadHrDepartmentLookupsSafe() {
  try { return await hrDepartmentsApi.lookups(); }
  catch (_e) { return null; }
}

export default hrDepartmentsApi;
